import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ShoppingCartIcon } from 'lucide-react';
// Sample data for notifications
const salesData = [{
  name: 'María G.',
  location: 'Madrid',
  time: '2 minutos'
}, {
  name: 'Carlos R.',
  location: 'Barcelona',
  time: '5 minutos'
}, {
  name: 'Laura S.',
  location: 'Sevilla',
  time: '8 minutos'
}, {
  name: 'Javier M.',
  location: 'Valencia',
  time: '12 minutos'
}, {
  name: 'Ana P.',
  location: 'Málaga',
  time: '15 minutos'
}, {
  name: 'Roberto L.',
  location: 'Bilbao',
  time: '18 minutos'
}, {
  name: 'Elena T.',
  location: 'Zaragoza',
  time: '22 minutos'
}, {
  name: 'Miguel A.',
  location: 'Murcia',
  time: '25 minutos'
}];
const SalesPopNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSale, setCurrentSale] = useState(salesData[0]);
  const [saleIndex, setSaleIndex] = useState(0);
  // Close notification manually
  const handleClose = () => {
    setIsVisible(false);
  };
  // Show a new notification periodically
  useEffect(() => {
    // First notification appears after 5 seconds
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  // Cycle through notifications
  useEffect(() => {
    if (!isVisible) return;
    // Hide after 5 seconds
    const hideTimeout = setTimeout(() => {
      setIsVisible(false);
    }, 5000);
    // Prepare next notification
    const nextTimeout = setTimeout(() => {
      const nextIndex = (saleIndex + 1) % salesData.length;
      setSaleIndex(nextIndex);
      setCurrentSale(salesData[nextIndex]);
      setIsVisible(true);
    }, 10000);
    return () => {
      clearTimeout(hideTimeout);
      clearTimeout(nextTimeout);
    };
  }, [isVisible, saleIndex]);
  return <AnimatePresence data-id="element-296">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} className="fixed bottom-4 left-4 z-50 max-w-xs bg-white rounded-lg shadow-lg p-4 border-l-4 border-[#FF6B3C]" data-id="element-297">
          <button onClick={handleClose} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" aria-label="Cerrar notificación" data-id="element-298">
            <XIcon size={16} data-id="element-299" />
          </button>
          <div className="flex items-start" data-id="element-300">
            <div className="flex-shrink-0 bg-[#FF6B3C] rounded-full p-2 mr-3" data-id="element-301">
              <ShoppingCartIcon className="h-5 w-5 text-white" data-id="element-302" />
            </div>
            <div data-id="element-303">
              <p className="font-medium text-gray-900" data-id="element-304">
                {currentSale.name} de {currentSale.location}
              </p>
              <p className="text-sm text-gray-600" data-id="element-305">
                compró{' '}
                <span className="font-semibold" data-id="element-306">La Cena Que Te Salva</span>
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-307">
                Hace {currentSale.time}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};
export default SalesPopNotification;